<template>
  <div class="my-2">
    <h4>Historical Team Performance</h4>

    <b-spinner
      v-if="loading"
      label="Loading..."
      class="my-5 d-block mx-auto"
      variant="primary"
      style="width: 3rem; height: 3rem;"
    />

    <div v-else>
      <div v-if="stats.length">
        <b-table
          :items="stats"
          :fields="mainFields"
          responsive
          bordered
          hover
          show-details
          :detail-row-class="() => 'bg-light'"
        >
          <template #cell(details)="row">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="row.toggleDetails"
            >
              {{ row.detailsShowing ? 'Hide' : 'Show' }} Captains
            </b-button>
          </template>

          <template #row-details="row">
            <b-table
              :items="row.item.captainStats"
              :fields="captainFields"
              small
              bordered
              responsive
              class="mb-0"
            />
          </template>
        </b-table>
      </div>

      <div
        v-else
        class="text-center text-muted"
      >
        <p>No historical stats available for this team.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
import {
  BSpinner, BTable, BButton, VBToggle,
} from 'bootstrap-vue'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BSpinner, BTable, BButton,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  props: {
    teamId: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const stats = ref([])
    const loading = ref(true)

    const mainFields = [
      { key: 'levelNumber', label: 'Level' },
      { key: 'totalCaptains', label: 'Total Captains' },
      { key: 'totalCompletedTrips', label: 'Completed Trips' },
      { key: 'details', label: 'Captain Stats', class: 'text-center' },
    ]

    const captainFields = [
      { key: 'name', label: 'Captain Name' },
      { key: 'completedTrips', label: 'Completed Trips' },
    ]

    const fetchStats = async () => {
      try {
        const res = await axiosIns.get(`/teams/${props.teamId}/level-stats`)
        stats.value = res.data.data
      } catch (error) {
        console.error('Error fetching stats:', error)
      } finally {
        loading.value = false
      }
    }

    const onRowToggled = (row, expanded) => {
      // Optional: handle expansion logic
      console.log('Row toggled:', row.item, expanded)
    }

    onMounted(fetchStats)

    return {
      stats,
      loading,
      mainFields,
      captainFields,
      onRowToggled,
    }
  },
}
</script>
